import React from 'react';
import { Container, Box } from '@mui/material';
import ProfileGrid from '../components/ProfileGrid';

const Home = () => (
  <Box className="gallery-page" sx={{ width: '100%', maxWidth: '100%', overflow: 'hidden' }}>
    {/* pt deja pasar el AppBar fijo. Los margenes laterales se resuelven con
        breakpoints en vez de con useMediaQuery: menos JS, mismo resultado. */}
    <Container
      maxWidth="xl"
      sx={{
        pt: { xs: 7, sm: 10 },
        pb: 8,
        px: { xs: 2, sm: 4, md: 6 },
        width: '100%',
        maxWidth: '100%'
      }}
    >
      <ProfileGrid />
    </Container>
  </Box>
);

export default Home;
